// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.currency-selector label {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.currency-select {
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s;
  font-size: 0.875rem;
  min-width: 80px;
}

.currency-select:hover:not(:disabled) {
  border-color: #9ca3af;
}

.currency-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.currency-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f3f4f6;
}

.currency-error {
  font-size: 0.75rem;
  color: #ef4444;
}

/* Responsive */
@media (max-width: 640px) {
  .currency-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .currency-select {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CurrencySelector/CurrencySelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".currency-selector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.currency-selector label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 0.875rem;\n}\n\n.currency-select {\n  padding: 0.5rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  font-size: 0.875rem;\n  min-width: 80px;\n}\n\n.currency-select:hover:not(:disabled) {\n  border-color: #9ca3af;\n}\n\n.currency-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.currency-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #f3f4f6;\n}\n\n.currency-error {\n  font-size: 0.75rem;\n  color: #ef4444;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .currency-selector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n  }\n  \n  .currency-select {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
